export default __webpack_public_path__ + "media/images/logo-d4b5dc90fd3e117d141ae7053b157f58.svg";